export function Stat({ label, value }: { label: string; value: string | undefined | null }) {
  return (
    <div className="flex items-center justify-between gap-2">
      <span className="text-xs uppercase tracking-wide text-muted-foreground">{label}</span>
      <span className="font-mono text-xs">{value ?? '—'}</span>
    </div>
  );
}
